import { AfterViewInit, Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";
import { UtilsProvider } from '../../../common/providers/utils-provider.service';
import { CurrentUser } from '../../../common/providers/current-user';
import { TeamRow, TeamsProvider } from '../../providers/teams-provider';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Athlete } from "../../../common/models/athlete";
import { User } from "../../../common/models/user";
import { Organization } from "../../../common/models/organization";
import { OrganizationRole } from "../../../common/models/organization-role";
import { Team } from "../../../common/models/team";
import { MatButtonModule, MatIconButton } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatInput } from "@angular/material/input";
import { MatProgressBar } from "@angular/material/progress-bar";
import { NgIf } from "@angular/common";
import { Observable } from "rxjs";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";

@Component({
  selector: 'teams-form',
  providers: [],
  styleUrls: ['./form.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconButton,
    TranslateModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatTooltip,
    ReactiveFormsModule,
    MatInput,
    MatProgressBar,
    NgIf,
    CdkTextareaAutosize
  ],
  templateUrl: './form.html'
})
export class TeamsFormComponent implements AfterViewInit {
    public readonly NAME_MAX_LENGTH: number = 200;
    public readonly DESCRIPTION_MAX_LENGTH: number = 1000;
    public isLoading = false;
    public isAdmin = false;

    public formTitle = '';
    public confirmButtonTitle = 'Save';

    public availableAthletes: Athlete[] = [];
    public availableCoaches: User[] = [];

    public organisation: Organization = {} as Organization;
    public teamId = 0;

    public nameFormControl: FormControl = new FormControl('', [
        Validators.required
    ]);
    public teamDescriptionFormControl: FormControl = new FormControl('');

    private _rights: number[] = [];
    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        public utils: UtilsProvider,
        public dialog: MatDialogRef<TeamsFormComponent>,
        private _toaster: MatSnackBar,
        private _teamsProvider: TeamsProvider,
        private _translater: TranslateService,
        private _currentUserRoles: CurrentUserRolesProvider,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        this.availableCoaches = this._data.availableCoaches;
        this.availableAthletes = this._data.availableAthletes;
        this.organisation = _data.organization;

        this._rights = this._currentUserRoles.getRolesIds(this.organisation.id!);
        if (this._rights.length && this._rights.indexOf(OrganizationRole.ID_ADMIN) >= 0) {
            this.isAdmin = true;
        }

        if (this._data.teamRow) {

            this.teamId = this._data.teamRow.team.id;
            this.nameFormControl.setValue(this._data.teamRow.team.name);
            this.teamDescriptionFormControl.setValue(this._data.teamRow.team.description);

        }

        this.formTitle = this._data.formTitle;
        this.confirmButtonTitle = this._data.confirmButtonTitle;
    }

    public ngAfterViewInit() {
    }

    public onSaveClicked(): void {
        if (this.canSave()) {
            this.isLoading = true;
            this.save().subscribe({
                next: (result: TeamRow) => {
                    this._toaster.open(this._translater.instant('Team_saved'), '', { duration: 5000 });
                    this.isLoading = false;
                    this.dialog.close(result);
                },
                error: (error: any) => this.onError(error)
            });
        } else {
            this._toaster.open(this._translater.instant('Correct_form_errors'), '', { duration: 5000 });
        }
    }

    public canSave(): boolean {

        return !this.isLoading
            && !this.nameFormControl.invalid;
    }

    private save(): Observable<TeamRow> {
      const teamRow: TeamRow = {
          team: {} as Team,
          coaches: [],
          athletes: [],
          coachNames: '',
      };

      // team
      teamRow.team.id = this.teamId;
      teamRow.team.name = this.nameFormControl.value;
      teamRow.team.organizationId = this.organisation.id!;
      teamRow.team.description = this.teamDescriptionFormControl.value;

      return this._teamsProvider.saveTeam(this.organisation.id!, teamRow)
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 422) {
            if (error.error.errors && error.error.errors.email) {
                // c'est qu'on a essayé de faire valider un email test@test par exemple (c'est validé par le validator angular mais pas laravel...)
                return;
            }
        }

        this._toaster.open(this._translater.instant('Error_unknown'), '', { duration: 5000 });
    }

}
